import HistoryYearAtGlanceSection from 'components/Content/BeautyInsider/BeautyInsiderHistory/HistoryYearAtGlanceSection/HistoryYearAtGlanceSection';

export default HistoryYearAtGlanceSection;
